import React from 'react'
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const SideButton = () => {
    return (
        <>
            <div className='sideButtons'>

                <div className="SideCallButton">

                    <span className='icon'>
                        <CallIcon />
                    </span>
                    <span className='text'>
                        <a href="tel:+918811099994" style={{ textDecoration: 'none', color: 'white' }}>
                            <div>
                                Admission Helpline
                            </div>
                            <div>
                                +91 88110 99994
                            </div>
                        </a>
                    </span>

                </div>
                <br />
                <div className="SideWAButton">

                    <span className='icon'>
                        <WhatsAppIcon />
                    </span>

                    <span className='text'>
                        <a href="https://wa.me/+918811099994/?text=Hello"  style={{ textDecoration: 'none', color: 'white' }}>
                            <div>
                                Whatsapp Us
                            </div>
                            <div>
                                +91 88110 99994
                            </div>
                        </a>
                    </span>
                </div>
            </div>
        </>
    )
}

export default SideButton;